module.exports = __webpack_public_path__ + "img/kommune-1219.b8eddc59.svg";